import { createContext } from 'react';
import { IEnrollmentContextValue } from './types';

const PatientEnrollmentOptionsContext = createContext<IEnrollmentContextValue | null>(null);

export default PatientEnrollmentOptionsContext;
